import { DateTime } from 'luxon';
import type { DecoratedExperienceEvent } from '@/features/events/types';
import { sortByNextStartDate } from './recurrence.lib';

/**
 * Trim a decorated event list to upcoming events only, then sort by next start
 * date. "Today" is resolved in the given display timezone. Multi-day and
 * recurring events that began in the past but extend into today or later are
 * retained via lastEndDate / lastEndDateTime.
 */
export const filterUpcomingEvents = (
  events: DecoratedExperienceEvent[],
  displayTimezone: string
): DecoratedExperienceEvent[] => {
  const today = DateTime.local({ zone: displayTimezone }).startOf('day');
  const upcoming = events.filter(
    (event) =>
      event.startDate >= today ||
      (event.lastEndDate && event.lastEndDate > today) ||
      (event.lastEndDateTime && event.lastEndDateTime > today)
  );

  return sortByNextStartDate(upcoming, displayTimezone);
};
